import Vue from 'vue'
import VYouPin  from './youpin'

export default VYouPin



// WEBPACK FOOTER //
// ./src/components/index/mobile/youpin/index.js